'use client';

import Image from "next/image";

type Testimonial = {
  image?: string;
  name: string;
  role: string;
  text: string;
};

type TestimonialSectionProps = {
  heading?: string;
  testimonials: Testimonial[];
  columns?: number;
};

export function TestimonialSection({
  heading,
  testimonials,
  columns = 4,
}: TestimonialSectionProps) {
  const gridCols = {
    1: "grid-cols-1",
    2: "grid-cols-1 md:grid-cols-2",
    3: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
    4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
  }[columns] || "grid-cols-1 md:grid-cols-2 lg:grid-cols-4";

  return (
    <div className="w-full">
      {heading && (
        <h2 className="text-3xl md:text-4xl font-bold text-primary-700 mb-8">
          {heading}
        </h2>
      )}
      <div className={`grid ${gridCols} gap-6`}>
        {testimonials.map((testimonial, index) => (
          <div key={index} className="flex flex-col items-center text-center">
            {/* Profile Image */}
            {testimonial.image && (
              <div className="mb-4 relative">
                <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-primary-700 flex items-center justify-center bg-gray-100">
                  <Image
                    src={testimonial.image}
                    alt={testimonial.name}
                    width={96}
                    height={96}
                    className="object-cover w-full h-full"
                  />
                </div>
              </div>
            )}

            {/* Name */}
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              {testimonial.name}
            </h3>

            {/* Role */}
            <p className="text-sm text-gray-600 mb-3">
              {testimonial.role}
            </p>

            {/* Testimonial Text */}
            <p className="text-sm text-gray-700 leading-relaxed">
              {testimonial.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
